import {
  Cloud,
  CreditCard,
  TrendingUp,
  Truck,
  ClipboardList,
  BarChart3
} from "lucide-react";

// Offsets in px from the centre of the diagram — six hexagon vertices at r=150
const INTEGRATIONS = [
  { label: "Weather Info", Icon: Cloud, x: -75, y: -130 },
  { label: "Credit Data", Icon: CreditCard, x: 75, y: -130 },
  { label: "Risk Scoring", Icon: TrendingUp, x: -150, y: 0 },
  { label: "Freight", Icon: Truck, x: 150, y: 0 },
  { label: "Claim Data", Icon: ClipboardList, x: -75, y: 130 },
  { label: "Financial Data", Icon: BarChart3, x: 75, y: 130 }
];

function IntegrationCard({ label, Icon, x, y }) {
  return (
    <div
      className="absolute left-1/2 top-1/2 z-10 w-[122px]"
      style={{
        transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`
      }}
    >
      <div className="flex flex-col items-center gap-2 rounded-2xl bg-white px-3 py-4 shadow-[0_8px_24px_rgba(10,20,60,0.25)]">
        <Icon className="h-6 w-6 text-[#F26522]" strokeWidth={1.75} />
        <span className="text-center text-[13px] font-semibold leading-tight text-gray-800">
          {label}
        </span>
      </div>
    </div>
  );
}

export default function AuthBrandingPanel() {
  return (
    <div
      className="hidden lg:flex lg:w-1/2 flex-col p-8 relative overflow-hidden"
      style={{
        background:
          "radial-gradient(120% 120% at 18% 34%, #2B54B4 0%, #1D3E97 38%, #16295F 100%)"
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3">
        <img
          src="/logo.svg"
          alt="Orbit Logo"
          className="w-10 h-10 brightness-0 invert"
        />
        <span className="text-xl font-bold text-white">Nativeorange Orbit</span>
      </div>

      {/* Integration Diagram */}
      <div className="flex-1 flex items-center justify-center">
        <div className="relative w-[420px] h-[360px]">
          {/* Dashed hexagon connecting the integrations */}
          <svg
            className="absolute inset-0 h-full w-full"
            viewBox="0 0 420 360"
            style={{ zIndex: 0 }}
          >
            <polygon
              points="135,50 285,50 360,180 285,310 135,310 60,180"
              fill="none"
              stroke="rgba(255,255,255,0.35)"
              strokeWidth="1.5"
              strokeDasharray="6 7"
            />
          </svg>

          {/* Center Orbit Badge */}
          <div className="absolute left-1/2 top-1/2 z-20 flex h-[142px] w-[142px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-[#FFFFFF] shadow-[0_10px_30px_rgba(242,101,34,0.35)]">
            <img src="/logo.svg" alt="Orbit" className="h-9 w-9" />
            <span className="mt-2 text-lg font-semibold text-blue-500">
              Orbit
            </span>
          </div>

          {/* Surrounding Integration Cards */}
          {INTEGRATIONS.map((integration) => (
            <IntegrationCard key={integration.label} {...integration} />
          ))}
        </div>
      </div>

      {/* Bottom Text */}
      <div className="text-center">
        <h2 className="text-3xl font-bold text-white mb-2">
          One-Click Integration
          <br />
          Ecosystem
        </h2>
        <p className="text-blue-200">
          Seamlessly connect your API to carriers &amp; agencies
        </p>
      </div>
    </div>
  );
}
